function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import Popover from 'researcher/components/Popover';
import { price } from 'researcher/helpers/price';
import { recordStartFreeTrialClick, recordStart14DayTrialClick } from 'researcher/helpers/gtm';
import featureEnabled from 'shared/helper/feature';
import { getChinaLocalization } from 'shared/account/reducer';
import { T, useTranslate } from 'shared/helper/translate';
import ConfirmActivationModal from 'rubriq/plan/ConfirmActivationModal';
import { startSubscriptionImmediately } from 'rubriq/actions';
import { trackTryFreeClick, trackUpgradeClick, trackSubscriptionEndedClick } from 'rubriq/helpers/navbarTracking';
import { getIsPastDue, getTrialFingerprintFlagged } from 'rubriq/reducer';
import useCardlessTrial from 'rubriq/plan/useCardlessTrial';
import StartTrialConfirmationModal from 'rubriq/plan/StartTrialConfirmationModal';
import { getApiBaseUrl } from 'shared/helper/request';
var NavbarTrialStatus = function NavbarTrialStatus() {
  var _plan$paddleSubscript, _curie$status, _plans$premium, _plans$premium2, _plans$premium3, _plan$paddleSubscript2, _plans$premium4, _plans$premium5, _plans$premium6, _plans$premium7, _plans$premium8, _plans$premium9, _plans$premium10, _plans$premium11, _plans$premium12, _plans$premium13, _plans$premium14, _plans$premium15, _plans$premium16, _plans$premium17, _plans$premium18, _plans$premium19, _plans$premium20;
  var transactionPreview = useSelector(function (state) {
    return state.curie.transactionPreview;
  });
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie,
    user = _useSelector.user;
  var dispatch = useDispatch();
  var navigate = useNavigate();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var skipActivationModal = featureEnabled('rubriq_activation_modal');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showActivationModal = _useState2[0],
    setShowActivationModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showTrialConfirmModal = _useState4[0],
    setShowTrialConfirmModal = _useState4[1];
  // ROW cardless trial plan (premium_editing_only_cardless_trial), started via the backend.
  var cardlessTrial = useCardlessTrial();
  var isPastDue = useSelector(getIsPastDue);
  var trialFingerprintFlagged = useSelector(getTrialFingerprintFlagged);
  var TRIAL_MAX_DAYS = 7;
  var CHINA_TRIAL_MAX_DAYS = 14;
  var plan = curie === null || curie === void 0 ? void 0 : curie.plan;
  var plans = curie === null || curie === void 0 ? void 0 : curie.plans;
  var subscriptionId = plan === null || plan === void 0 || (_plan$paddleSubscript = plan.paddleSubscription) === null || _plan$paddleSubscript === void 0 ? void 0 : _plan$paddleSubscript.paddleId;
  var paddlePendingPlanUpdate = (curie === null || curie === void 0 || (_curie$status = curie.status) === null || _curie$status === void 0 ? void 0 : _curie$status.paddlePending) === true;
  var hasActiveTrial = (plans === null || plans === void 0 || (_plans$premium = plans.premium) === null || _plans$premium === void 0 ? void 0 : _plans$premium.paymentStatus) === 'trialing';
  var isCancelledTrial = (plans === null || plans === void 0 || (_plans$premium2 = plans.premium) === null || _plans$premium2 === void 0 ? void 0 : _plans$premium2.status) === 'cancelled' && (plans === null || plans === void 0 || (_plans$premium3 = plans.premium) === null || _plans$premium3 === void 0 ? void 0 : _plans$premium3.cancelState) === 'trial';

  // A cardless trial has no payment method on file — detected via the flag
  // stored on the PaddleSubscription entity and serialised into the plan response.
  var isCardlessTrial = (plan === null || plan === void 0 || (_plan$paddleSubscript2 = plan.paddleSubscription) === null || _plan$paddleSubscript2 === void 0 ? void 0 : _plan$paddleSubscript2.isCardlessTrial) === true;
  var cardlessTrialEnabled = featureEnabled('rubriq_cardless_free_trial');

  // A paid (nontrial) cancellation still within the paid period retains access —
  // UNLESS the subscription was previously past-due (payment failed before cancel).
  // pastDueStartedAt is non-null when the subscription ever entered past_due.
  var isCancelledNonTrialWithinPaidPeriod = (plans === null || plans === void 0 || (_plans$premium4 = plans.premium) === null || _plans$premium4 === void 0 ? void 0 : _plans$premium4.status) === 'cancelled' && (plans === null || plans === void 0 || (_plans$premium5 = plans.premium) === null || _plans$premium5 === void 0 ? void 0 : _plans$premium5.cancelState) === 'nontrial' && (plans === null || plans === void 0 || (_plans$premium6 = plans.premium) === null || _plans$premium6 === void 0 ? void 0 : _plans$premium6.paymentStatus) === 'active' && moment(plans === null || plans === void 0 || (_plans$premium7 = plans.premium) === null || _plans$premium7 === void 0 ? void 0 : _plans$premium7.endsAt).utc().isAfter(moment().utc()) && !(plans !== null && plans !== void 0 && (_plans$premium8 = plans.premium) !== null && _plans$premium8 !== void 0 && _plans$premium8.pastDueStartedAt);
  var hasPremium = (plans === null || plans === void 0 || (_plans$premium9 = plans.premium) === null || _plans$premium9 === void 0 ? void 0 : _plans$premium9.paymentStatus) === 'active' && (plans === null || plans === void 0 || (_plans$premium10 = plans.premium) === null || _plans$premium10 === void 0 ? void 0 : _plans$premium10.cancelState) !== 'trial' && (plans === null || plans === void 0 || (_plans$premium11 = plans.premium) === null || _plans$premium11 === void 0 ? void 0 : _plans$premium11.status) !== 'expired' && ((plans === null || plans === void 0 || (_plans$premium12 = plans.premium) === null || _plans$premium12 === void 0 ? void 0 : _plans$premium12.status) !== 'cancelled' || isCancelledNonTrialWithinPaidPeriod);
  var isTrialPlanExpired = (plans === null || plans === void 0 || (_plans$premium13 = plans.premium) === null || _plans$premium13 === void 0 ? void 0 : _plans$premium13.status) === 'expired' && (plans === null || plans === void 0 || (_plans$premium14 = plans.premium) === null || _plans$premium14 === void 0 ? void 0 : _plans$premium14.planPaidPrice) === null;
  // All cancelled nontrial plans past their end date, OR cancelled after a payment failure = ended.
  var isPaidPlanExpired = ((plans === null || plans === void 0 || (_plans$premium15 = plans.premium) === null || _plans$premium15 === void 0 ? void 0 : _plans$premium15.status) === 'expired' || (plans === null || plans === void 0 || (_plans$premium16 = plans.premium) === null || _plans$premium16 === void 0 ? void 0 : _plans$premium16.status) === 'cancelled' && (plans === null || plans === void 0 || (_plans$premium17 = plans.premium) === null || _plans$premium17 === void 0 ? void 0 : _plans$premium17.cancelState) === 'nontrial' && !isCancelledNonTrialWithinPaidPeriod) && (isChinaUser || (plans === null || plans === void 0 || (_plans$premium18 = plans.premium) === null || _plans$premium18 === void 0 ? void 0 : _plans$premium18.planPaidPrice) !== null);
  var endsAt = plans === null || plans === void 0 || (_plans$premium19 = plans.premium) === null || _plans$premium19 === void 0 ? void 0 : _plans$premium19.endsAt;
  var trialDaysRemaining = Math.max(1, Math.ceil(moment(endsAt).utc().diff(moment().utc(), 'hours') / 24));
  var chinaTrial = plans === null || plans === void 0 ? void 0 : plans.free_trial;
  var hasChinaTrial = !!chinaTrial;
  var hasActiveChinaTrial = hasChinaTrial && chinaTrial.status === 'active';
  var hasExpiredChinaTrial = hasChinaTrial && chinaTrial.status === 'expired';
  var chinaTrialExpirationDate = chinaTrial === null || chinaTrial === void 0 ? void 0 : chinaTrial.endsAt;
  var chinaTrialDaysRemaining;
  if (hasChinaTrial) {
    chinaTrialDaysRemaining = hasExpiredChinaTrial ? 0 : Math.max(1, moment(chinaTrialExpirationDate).utc().diff(moment().utc(), 'days'));
  }
  var currentPlanName = plans === null || plans === void 0 || (_plans$premium20 = plans.premium) === null || _plans$premium20 === void 0 ? void 0 : _plans$premium20.planName;
  var isTranslationPlan = isChinaUser ? currentPlanName === 'premium' : currentPlanName === 'premium_including_translation' || currentPlanName === 'premium_including_translation_no_trial';
  var planName = isTranslationPlan ? 'Rubriq Premium with Translation' : 'Rubriq Premium';
  var handleFreeTrialCLick = function handleFreeTrialCLick() {
    recordStartFreeTrialClick({
      buttonText: t('Start Free Trial')
    });
  };
  var handleStartTrialConfirm = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _plan$planPrice, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isChinaUser) {
              _context.next = 4;
              break;
            }
            recordStart14DayTrialClick({
              buttonId: 'start_14day_free_trial_btn_editing',
              productName: 'Rubriq Premium',
              displayedPrice: (plan === null || plan === void 0 || (_plan$planPrice = plan.planPrice) === null || _plan$planPrice === void 0 ? void 0 : _plan$planPrice.toString()) || ''
            });
            setTimeout(function () {
              window.location.href = "".concat(getApiBaseUrl(), "/c/CurieFreeTrialChina");
            }, 1000);
            return _context.abrupt("return");
          case 4:
            _context.next = 6;
            return cardlessTrial.start('navbar');
          case 6:
            response = _context.sent;
            if (response !== null && response !== void 0 && response.success) {
              setShowTrialConfirmModal(false);
              navigate('/rubriq');
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleStartTrialConfirm() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleUpgradeClick = function handleUpgradeClick() {
    if (useCartInsteadOfPaddle) {
      navigate('/rubriq/plan/subscribe');
      return;
    }

    // Under rubriq_cardless_free_trial: ROW (Paddle Billing) users always see
    // the non-trial pricing list — never the single-plan ConfirmActivationModal.
    if (cardlessTrialEnabled) {
      navigate('/rubriq/plan/subscribe');
      return;
    }
    if (skipActivationModal) {
      navigate('/rubriq/plan/subscribe');
      return;
    }
    setShowActivationModal(true);
  };
  var handleConfirmActivation = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (subscriptionId) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return dispatch(startSubscriptionImmediately(subscriptionId));
          case 4:
            setShowActivationModal(false);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleConfirmActivation() {
      return _ref2.apply(this, arguments);
    };
  }();
  var getCurrencySymbol = function getCurrencySymbol(currencyCode) {
    var formatter = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currencyCode
    });
    return formatter.formatToParts(0).find(function (part) {
      return part.type === 'currency';
    }).value;
  };
  var getRenewDateFromToday = function getRenewDateFromToday(interval) {
    return moment().add(1, interval === 'monthly' ? 'month' : 'year');
  };
  var getCuriePlanPrice = function getCuriePlanPrice() {
    // China does NOT use Paddle
    if (isChinaUser) {
      return price(user.currency, plan.planPrice, true, true);
    }

    // ROW users use Paddle preview pricing
    if (transactionPreview !== null && transactionPreview !== void 0 && transactionPreview.formattedTotal) {
      return transactionPreview.formattedTotal;
    }

    // fallback if Paddle preview not ready/failed
    return price(user.currency, plan.planPrice, true, true);
  };
  var handleUpgradeNowClick = function handleUpgradeNowClick() {
    if (useCartInsteadOfPaddle) {
      if (currentPlanName === 'premium') {
        navigate('/rubriq/subscribe/cart/translation');
      } else {
        navigate('/rubriq/subscribe/cart/editing');
      }
    } else if (currentPlanName === 'premium_editing_only' || currentPlanName === 'premium_editing_only_admin' || currentPlanName === 'premium_editing_only_no_trial') {
      navigate('/rubriq/plan/subscribe/freetrial');
    } else if (currentPlanName === 'premium_including_translation' || currentPlanName === 'premium_including_translation_no_trial') {
      navigate('/rubriq/plan/subscribe/premium');
    } else {
      navigate('/rubriq/plan/subscribe');
    }
  };
  var handleTrialUpgradeNowClick = function handleTrialUpgradeNowClick() {
    navigate('/rubriq/plan/subscribe');
  };
  if (!(curie !== null && curie !== void 0 && curie.loaded)) {
    return /*#__PURE__*/React.createElement("span", {
      className: "spinner-border spinner-border-sm ms-3",
      role: "status",
      "aria-hidden": "true"
    });
  }
  if (hasPremium) {
    return /*#__PURE__*/React.createElement(Popover, {
      content: planName,
      className: "plan-name-popover",
      "data-bs-toggle": "tooltip",
      "data-bs-placement": "bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ms-2",
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '2.5rem',
        height: '2.5rem',
        borderRadius: '50%',
        backgroundColor: '#e8f5f4',
        cursor: 'pointer'
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-sharp fa-solid fa-crown"
    })));
  }
  if (hasActiveChinaTrial && !hasPremium) {
    if (chinaTrialDaysRemaining > CHINA_TRIAL_MAX_DAYS) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex align-items-center gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "trial-status-text fw-bold",
        style: {
          color: '#E17100'
        }
      }, /*#__PURE__*/React.createElement(T, {
        source: "Trial ended"
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "nav-button btn btn-primary m-0",
        onClick: function onClick() {
          if (!isChinaUser) {
            trackUpgradeClick();
          }
          handleUpgradeClick();
        }
      }, /*#__PURE__*/React.createElement(T, {
        source: "Upgrade Now"
      })));
    }
    var chinaDayText = chinaTrialDaysRemaining === 1 ? 'd' : 'd';
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "trial-status-text",
      style: {
        color: '#6c757d'
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "Trial days",
      params: [chinaTrialDaysRemaining, chinaDayText]
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nav-button btn btn-primary m-0",
      onClick: function onClick() {
        if (!isChinaUser) {
          trackUpgradeClick();
        }
        handleUpgradeClick();
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "UPGRADE"
    })));
  }
  if (hasActiveTrial) {
    var dayText = trialDaysRemaining === 1 ? 'd' : 'd';

    // Cardless trial: user has no payment method — the UPGRADE button sends them to
    // the pricing/plans screen to choose a paid plan.
    if (cardlessTrialEnabled && isCardlessTrial) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex align-items-center gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "trial-status-text",
        style: {
          color: '#6c757d'
        }
      }, /*#__PURE__*/React.createElement(T, {
        source: "Trial days",
        params: [trialDaysRemaining, dayText]
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "nav-button btn btn-primary m-0",
        onClick: function onClick() {
          trackUpgradeClick();
          navigate('/rubriq/plan/subscribe');
        }
      }, /*#__PURE__*/React.createElement(T, {
        source: "UPGRADE"
      })));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConfirmActivationModal, {
      open: showActivationModal,
      amount: getCuriePlanPrice(),
      renewDate: getRenewDateFromToday(plan === null || plan === void 0 ? void 0 : plan.subscriptionInterval).format('DD MMM YYYY'),
      onConfirm: handleConfirmActivation,
      onClose: function onClose() {
        return setShowActivationModal(false);
      },
      revenue: getCuriePlanPrice()
    }), /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "trial-status-text",
      style: {
        color: '#6c757d'
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "Trial days",
      params: [trialDaysRemaining, dayText]
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nav-button btn btn-primary m-0",
      onClick: function onClick() {
        if (!isChinaUser) {
          trackUpgradeClick();
        }
        handleUpgradeClick();
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "UPGRADE"
    }))));
  }
  if (isCancelledTrial) {
    if (trialDaysRemaining > TRIAL_MAX_DAYS) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex align-items-center gap-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "trial-status-text fw-bold",
        style: {
          color: '#E17100'
        }
      }, /*#__PURE__*/React.createElement(T, {
        source: "Trial ended"
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "nav-button btn btn-primary m-0",
        onClick: function onClick() {
          if (!isChinaUser) {
            trackUpgradeClick();
          }
          handleTrialUpgradeNowClick();
        }
      }, /*#__PURE__*/React.createElement(T, {
        source: "Upgrade Now"
      })));
    }
    var _dayText = trialDaysRemaining === 1 ? 'd' : 'd';
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "trial-status-text",
      style: {
        color: '#6c757d'
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "Trial days",
      params: [trialDaysRemaining, _dayText]
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nav-button btn btn-primary m-0",
      disabled: true
    }, /*#__PURE__*/React.createElement(T, {
      source: "UPGRADE"
    })));
  }
  // Payment recovery grace period: while the user is in past_due state, their
  // subscription hasn't truly expired yet — suppress the "Trial ended" and
  // "Subscription ended" states so the navbar doesn't mislead them.
  // The PaymentRecoveryBanner on the workspace already informs them clearly.
  if (isPastDue) {
    return null;
  }
  if (paddlePendingPlanUpdate) {
    return null;
  }
  if (isTrialPlanExpired || hasExpiredChinaTrial) {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "trial-status-text fw-bold",
      style: {
        color: '#E17100'
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "Trial ended"
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "nav-button btn btn-primary m-0",
      onClick: function onClick() {
        if (!isChinaUser) {
          trackUpgradeClick();
        }
        handleTrialUpgradeNowClick();
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "Upgrade Now"
    })));
  }
  if (isPaidPlanExpired) {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center gap-2 ms-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "trial-status-text text-danger fw-bold"
    }, /*#__PURE__*/React.createElement(T, {
      source: "Subscription ended"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": t('Reactivate'),
      type: "button",
      className: "nav-button btn btn-primary m-0",
      onClick: function onClick() {
        trackSubscriptionEndedClick();
        handleUpgradeNowClick();
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "Reactivate"
    })));
  }
  if (plan !== null && plan !== void 0 && plan.preferredGroupCode) {
    return null;
  }

  // Treated as having already used the free trial: same CTA as after a trial.
  if (trialFingerprintFlagged) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      id: "upgrade_now_btn",
      className: "nav-button btn btn-primary m-0",
      onClick: function onClick() {
        trackUpgradeClick();
        handleTrialUpgradeNowClick();
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "Upgrade Now"
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StartTrialConfirmationModal, {
    open: showTrialConfirmModal,
    onClose: function onClose() {
      return setShowTrialConfirmModal(false);
    },
    onStartTrial: handleStartTrialConfirm,
    loading: cardlessTrial.loading,
    isChinaUser: isChinaUser
  }), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Try Rubriq for Free'),
    onClick: function onClick() {
      handleFreeTrialCLick();
      trackTryFreeClick();

      // ROW: cardless trial (modal → backend start, no card form).
      // China: existing trial flow (modal → CurieFreeTrialChina).
      if (cardlessTrial.available || cardlessTrialEnabled && isChinaUser) {
        setShowTrialConfirmModal(true);
        return;
      }
      navigate('/rubriq/plan');
    },
    id: "start_free_trial_btn",
    className: "nav-button color-white nav-button--try-free",
    "data-track": "click",
    "data-track-action": "button click",
    "data-track-label": "Try Rubriq for Free",
    type: "button"
  }, cardlessTrialEnabled ? /*#__PURE__*/React.createElement("span", {
    className: "nav-link nav-link-force-white"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Try Rubriq for Free"
  })) : /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Try Rubriq for Free'),
    href: "/rubriq/plan",
    className: "nav-link nav-link-force-white"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Try Rubriq for Free"
  }))));
};
export default NavbarTrialStatus;